// extracted by mini-css-extract-plugin
export default {"container":"homepage_container__Nc7kC","heading":"homepage_heading__i-1k9"};